//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import VueRecaptcha from "vue-recaptcha";
import md5 from "md5";
import { mapActions } from "vuex";
export default {
  name: "UserRegister",
  components: { VueRecaptcha },
  data: function() {
    return {
      user: {},
      model: null,
      isPwd: true,
      remember: false,
      forgotpwd: false,
      showLoading: false,
    };
  },
  methods: {
    ...mapActions(["getCurrentUser"]),
    sendMail(addr) {
      this.showLoading = true;
      this.$http
        .get("/user/mail/forgetpassword/" + addr)
        .then(async (result) => {
          this.$q.notify({
            icon: "done",
            color: "positive",
            message: "Email berhasil terkirim!",
          });
          this.showLoading = false;
          this.forgotpwd = false;
        })
        .catch((error) => {
          this.$q.notify({
            color: "negative",
            message: "Email yang anda masukkan tidak terdaftar sebagai user!",
          });
          this.showLoading = false;
          this.forgotpwd = false;
        });
    },
    login() {
      var usr = {};
      usr.username = this.user.username;
      usr.password = md5(this.user.password);
      this.$http.post("/login", usr, {}).then((result) => {
        localStorage.setItem("token-ppidbig", result.data);
        this.getCurrentUser();
        this.$router.push("/informasi/permohonan/buat");
      });
    },
  },
};
